import React from 'react'
import { useParams } from 'react-router-dom'
import CopyPlanFileDetail from '../../plan/CopyPlanFileDetail'
import V3PlanRouteShell from './V3PlanRouteShell'

export default function V3CopyPlanFileDetailPage() {
  const { '*': remainder = '' } = useParams()
  const isLineMode = remainder.startsWith('line/')

  return (
    <V3PlanRouteShell>
      <CopyPlanFileDetail mode={isLineMode ? 'line' : undefined} visualVariant="v3" />
    </V3PlanRouteShell>
  )
}

